/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@import url(https://fonts.googleapis.com/css2?family=Muli:ital,wght@0,400;0[_ngcontent-%COMP%], 500[_ngcontent-%COMP%];0[_ngcontent-%COMP%], 700[_ngcontent-%COMP%];1[_ngcontent-%COMP%], 400&display=swap)[_ngcontent-%COMP%];.lg-container[_ngcontent-%COMP%]{padding:1rem;color:#fff;background:#2e3e4e}.ace-editor[_ngcontent-%COMP%]{min-height:187px;max-height:187px;width:100%;overflow:hidden}cc-box[_ngcontent-%COMP%]     .main-box, cc-box[_ngcontent-%COMP%]     .main-box-header{border:0}"];
export { styles as styles };
